export default "/_next/static/assets/images/lotto/euromillions-logo.c5d2d37eeb8291cc36e9eb609db1bf07.png";